import React from 'react'
import { DatePicker } from '@scuf/common'
import styled from 'styled-components/macro'
import { translate } from 'react-translate'

const StyledDatePicker = styled(DatePicker)`
`
const FormDatePicker = ({
  input,
  t,
  meta: 
    { error, visited, submitFailed, touched },
  disabled
}) => {
  return (
    <div>
      <StyledDatePicker
        { ...input }
        {...(touched || submitFailed) && error
          ? { error: t(error) }
          : {}
        }
        disabled={disabled}
        fluid
      />
    </div>
  )
}

export default translate('FormInput')(FormDatePicker)
